import styled from 'styled-components';
import rightArrow from '../../images/policy/right-arrow.svg';
import OpdBackground from '../../images/newInsurerPage/OpdBg.svg';
import GmcBackground from '../../images/newInsurerPage/GmcBg.svg';
import ClaimsCardIconBackground from '../../images/newInsurerPage/claimscardiconBackground.svg';
import ClaimsCardIcon from '../../images/newInsurerPage/claimsCardIcon.svg';
import blueArrow from '../../images/newInsurerPage/blueArrow.svg';
import goldenArrow from '../../images/newInsurerPage/goldenArrow.svg';
import greenArrow from '../../images/newInsurerPage/greenArrow.svg';
import lightGreenArrow from '../../images/newInsurerPage/lightBlueArrow.svg';
import purpleArrow from '../../images/newInsurerPage/purpleArrow.svg';
import orangeArrow from '../../images/newInsurerPage/OrangeArrow.svg';
import MadicineOrderIcon from '../../images/newInsurerPage/MadicineOrderIcon.svg';
import reimbarsmentIcon from '../../images/newInsurerPage/ReimbarsmentIcon.svg';
import ClaimCardBg from '../../images/newInsurerPage/claimCardBg.svg';
import OnlineConsultBackground from '../../images/newInsurerPage/OnlineBackground.svg';
import OfflineConsultBackground from '../../images/newInsurerPage/OfflineBackground.svg';
import LabDiagnosticsBackground from '../../images/newInsurerPage/LabBackground.svg';
import AnnualHealthCheckupBackground from '../../images/newInsurerPage/AnnualCheckupBackground.svg';
import MadicineOrderBackground from '../../images/newInsurerPage/MadicineOrderBackground.svg';
import OnlineIcon from '../../images/newInsurerPage/OnlineConsultationIcon.svg';
import OfflineIcon from '../../images/newInsurerPage/OfflineCOnsultationIcon.svg';
import DblueArrow from '../../images/newInsurerPage/darkblueArrow.svg';
import LabsIcon from '../../images/newInsurerPage/LabDiagnosticsIcon.svg';
import AnnualHealthIcon from '../../images/newInsurerPage/AnnualHealthCheckupIcon.svg';
import MedicineOrderIcon from '../../images/newInsurerPage/MadicineOrderIcon.svg';
import ReimbarsmentBackground from '../../images/newInsurerPage/ReimbarsmentCardBackground.svg';
import Tappable from 'react-tappable/lib/Tappable';

const TappableCard = styled(Tappable)``;

const CardBody = styled.div`
  display: flex;
  //   justify-content: space-evenly;
  align-items: center;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`}};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  border: ${(props) => (props.borderColor ? '1px solid' : 'none')};
  border-image: ${(props) =>
    props.borderColor ? `${props.borderColor}` : 'none'};
  border-radius: 12px;
  padding: 15px 28px 15px 20px;
  margin-bottom: 1rem;
`;

const CardIcon = styled.img`
  // align-self: flex-start;
`;
const CardIconContainer = styled.div`
  display: flex;
  align-self: flex-start;
  height: 40px;
  width: 40px;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  border-radius: 1rem;
`;

const CardDetails = styled.div`
  padding: 0px 18px 0px 20px;
  text-align: left;
  flex: 1;
`;

const CardTitle = styled.p`
  font-family: Inter;
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  white-space: pre-wrap;
  margin-bottom: 8px;
`;

const CardSubtitle = styled.ul`
  display: flex;
  color: #171616;
  font-size: 10px;
  font-weight: 500;
  line-height: 150%; /* 15px */
  font-family: Inter;
  line-height: 15px;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
  line-height: 20px;
`;
const CardSubtitleSpan = styled.span`
  font-size: 12px;
  font-family: Inter;
  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
  line-height: 20px;
`;

const CardSubtitleType2 = styled.p`
  font-family: Inter;
  font-size: 10px;
  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: #171616;
  line-height: 20px;
`;

const RightArrow = styled.img`
  filter: ${(props) => (props.filter ? `${props.filter}` : 'none')};
`;

const getBackground = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return OpdBackground;
    case 'gmc-policy':
      return GmcBackground;
    case 'labs':
      return LabDiagnosticsBackground;
    case 'offline-consult':
      return OfflineConsultBackground;
    case 'online-consult':
      return OnlineConsultBackground;
    case 'pharmacy':
      return MadicineOrderBackground;
    case 'reimbursement':
      return ReimbarsmentBackground;
    default:
      return '';
  }
};
const getBackgroundColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'my-claims':
      return '#CDF';
    case 'labs':
      return 'linear-gradient(313deg,#CAF1EE 0%,#42ada769 100%)';
    case 'offline-consult':
      return 'linear-gradient(136deg, #FFE5BD 0%, #FFF9DA 100%)';
    case 'online-consult':
      return 'linear-gradient(136deg, #A7EAE5 0%, #CDFFFC 100%)';
    case 'pharmacy':
      return 'linear-gradient(127deg,#a57aff8f 0%,rgba(190,181,255,0.52) 100%)';
    case 'reimbursement':
      return 'linear-gradient(114deg,#FFE7D7 0%,#FFFAF7 100%)';
    default:
      return '';
  }
};
const getTextColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'my-claims':
      return '#ffbb00';
    case 'gmc-policy':
      return '#3880B4';
    case 'labs':
      return '#42ADA7';
    case 'offline-consult':
      return '#C37A08';
    case 'online-consult':
      return '#297166';
    case 'pharmacy':
      return '#7651DA';
    case 'reimbursement':
      return 'rgba(250, 133, 107, 1)';
    default:
      return '';
  }
};
const getIcon = (ThemeKey) => {
  switch (ThemeKey) {
    case 'labs':
      return LabsIcon;
    case 'offline-consult':
      return OfflineIcon;
    case 'online-consult':
      return OnlineIcon;
    case 'reimbursement':
      return reimbarsmentIcon;
    case 'pharmacy':
      return MadicineOrderIcon;
    default:
      return '';
  }
};
const getArrow = (ThemeKey) => {
  switch (ThemeKey) {
    case 'labs':
      return greenArrow;
    case 'offline-consult':
      return goldenArrow;
    case 'online-consult':
      return lightGreenArrow;
    case 'reimbursement':
      return orangeArrow;
    case 'pharmacy':
      return DblueArrow;
    default:
      return '';
  }
};

const getIconColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'reimbursement':
      return greenArrow;
    default:
      return '';
  }
};

const NewHealthBenefitsCard = (props) => {
  const iconStyle = {
    filter: `hue-rotate(120deg)`, // Adjust the degree as needed
  };
  console.log('props are ', props);
  if (props.data.themeKey !== 'reimbursement') {
    return (
      <Tappable onTap={props.onTap}>
        <CardBody
          bgSvg={getBackground(props.data.themeKey)}
          borderColor=""
          opacity="0.3"
          bgColor={getBackgroundColor(props.data.themeKey)}
        >
          <CardIconContainer bgSvg={ClaimsCardIconBackground} bgColor="#CDF">
            <CardIcon src={getIcon(props.data.themeKey)} alt="icon" />
          </CardIconContainer>

          <CardDetails>
            <CardTitle
              style={{
                whiteSpace: 'pre',
                color: getTextColor(props.data.themeKey),
              }}
            >
              {props.data.title}
            </CardTitle>
            {props.data.benefitsWithoutIcons &&
              props.data.benefitsWithoutIcons.map((item, index) => (
                <CardSubtitle>
                  <Bullet>&bull;</Bullet>
                  <li key={index}>{item.benefitText}</li>
                </CardSubtitle>
              ))}
          </CardDetails>
          <RightArrow
            src={getArrow(props.data.themeKey)}
            filter={props.filter}
          />
        </CardBody>
      </Tappable>
    );
  } else {
    return (
      <Tappable onTap={props.onTap}>
        <ReimbarsmentCardOuterDiv>
          <NewCardBody
            bgSvg={ReimbarsmentBackground}
            borderColor=""
            bgColor={getBackgroundColor(props.data.themeKey)}
          >
            <CardIconContainer bgSvg={ClaimsCardIconBackground} bgColor="#CDF">
              <CardIcon src={getIcon(props.data.themeKey)} alt="icon" />
            </CardIconContainer>

            <CardDetails>
              <CardTitle
                style={{
                  whiteSpace: 'pre',
                  color: getTextColor(props.data.themeKey),
                }}
              >
                {props.data.title}
              </CardTitle>
              {/* {props.data.benefitsWithoutIcons &&
              props.data.benefitsWithoutIcons.map((item, index) => (
                <CardSubtitle>
                  <li key={index}>{item.benefitText}</li>
                </CardSubtitle>
              ))} */}
            </CardDetails>
            <RightArrow
              src={getArrow(props.data.themeKey)}
              filter={props.filter}
            />
          </NewCardBody>
          <Bgdiv>
            {props.data.benefitsWithIcons &&
              props.data.benefitsWithIcons.map((item, index) => {
                return (
                  <ReimbarsmentCardDiv
                    borderBottom={
                      !(index === props.data.benefitsWithIcons.length - 1)
                    }
                  >
                    <IconBenefits>
                      <img
                        src={item.iconUrl}
                        //className="requiredIcon"
                        style={{
                          filter:
                            'brightness(0) saturate(100%) invert(71%) sepia(78%) saturate(1597%) hue-rotate(311deg) brightness(107%) contrast(97%)',
                          paddingTop: '0.5rem',
                          width: '20px',
                        }}
                      />
                    </IconBenefits>
                    <InnerDiv>
                      <InnerDivTitle>{item.title}</InnerDivTitle>
                      <InnerDivLists>
                        <Bullet>&bull;</Bullet>
                        {item.benefitText}
                      </InnerDivLists>
                    </InnerDiv>
                  </ReimbarsmentCardDiv>
                );
              })}
          </Bgdiv>
        </ReimbarsmentCardOuterDiv>
      </Tappable>
    );
  }
};

export default NewHealthBenefitsCard;

const ReimbarsmentCardOuterDiv = styled.div`
  margin-bottom: 1rem;
`;
const NewCardBody = styled.div`
  display: flex;
  //   justify-content: space-evenly;
  align-items: center;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  border: ${(props) => (props.borderColor ? '1px solid' : 'none')};
  border-image: ${(props) =>
    props.borderColor ? `${props.borderColor}` : 'none'};

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 15px 28px 15px 20px;
  //background: linear-gradient(316deg, #fff5ef 0%, #fff 100%);
`;
const Bgdiv = styled.div`
  background: linear-gradient(316deg, #fff5ef 0%, #fff 100%);
  padding-bottom: 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
`;
const ReimbarsmentCardDiv = styled.div`
  background: linear-gradient(316deg, #fff5ef 0%, #fff 100%);
  display: flex;
  padding-top: 1rem;
  width: 90%;
  margin: auto;
  border-bottom: ${(props) =>
    props.borderBottom ? '1px solid rgba(251, 148, 124, 0.2)' : ''};
  // border-bottom: 1px solid rgba(251, 148, 124, 0.2);
`;
const IconBenefits = styled.div`
  align-self: flex-start;
`;
const InnerDiv = styled.div`
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
`;
const InnerDivTitle = styled.div`
  color: #666;
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
`;
const InnerDivLists = styled.div`
  display: flex;
  color: #666;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
`;
const Bullet = styled.div`
  padding-right: 0.5rem;
`;
